module.exports = __webpack_public_path__ + "media/images/UCI-logo@3x-aa46c28b98470d15643d319de04e19cb.jpg";